import { TBoardId, TCardId } from '../../../types/types';
import { BOARDS_RECENT_CARDS_LOCALSTORAGE } from '../../../store/model/board/constants';

export const boardSetUserRecentCards = (
    boardId: TBoardId,
    recentCards: TCardId[],
) => {
    const data = localStorage.getItem(BOARDS_RECENT_CARDS_LOCALSTORAGE);
    const boards = data ? JSON.parse(data) : {};
    boards[boardId] = recentCards;
    localStorage.setItem(BOARDS_RECENT_CARDS_LOCALSTORAGE, JSON.stringify(boards));
};
